import React from "react";

export default function SQLServer_ISNULL() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_ISNULL</h1>
      <p>This is the SQLServer_ISNULL component generated from the SQL JSON.</p>
    </div>
  );
}
